import Vue from "vue"
import Vue2TouchEvents from 'vue2-touch-events'

// Vue.use(Vue2TouchEvents, {
//   disableClick: false,
//   touchHoldTolerance: 300,
//   swipeTolerance: 15,
// })
Vue.use(Vue2TouchEvents)
